// extracted by mini-css-extract-plugin
export default {"imageContainer":"MediaViewerMobile-module-imageContainer-nZ7pb"};